// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__30X1K","inputWrap":"Table_inputWrap__3Ou0F","col":"Table_col__1bNFR","bmiTooltip":"Table_bmiTooltip__1MHsM"};